/** * @file ZipcodeSearch */
<template>
  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
    <el-col :span="1" class="u-w--auto">〒</el-col>
    <el-col :span="5" class="u-w--150">
      <el-input
        type="tel"
        placeholder=""
        maxlength="8"
        :name="name"
        :data-validator-name="dataValidationName"
        v-model="zipcodeModel"
        @blur="handleBlur"
      />
      <input type="text" :id="`${name}_search`" class="post_search" />
    </el-col>
    <el-col :span="4" :class="buttonWidthMobileFlg ? 'u-w--100' : 'u-w--120'">
      <el-button @click="handleClickSearch">住所検索</el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    dataValidationName: {
      type: String,
      default: null
    },
    zipcodeVal: {
      type: [String, Number],
      default: null
    },
    handleBlur: {
      type: Function,
      default: () => {}
    },
    handleClickSearch: {
      type: Function,
      default: () => {}
    },
    buttonWidthMobileFlg: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    zipcodeModel: {
      get() {
        return this.zipcodeVal
      },
      set(val) {
        this.$emit('update:zipcodeVal', val)
      }
    }
  }
}
</script>
<style lang="scss">
.post_search {
  display: none;
}
</style>
